import React, { FunctionComponent } from 'react';
import PrimaryButtonWrapper, { AriaDescription } from './PrimaryButtonWrapper.style';
import { Colors } from '../../../../types';
import { IPrimaryButtonProps } from '../../../../types/buttonTypes';

const PrimaryButton: FunctionComponent<IPrimaryButtonProps> = ({ children, disabled, ...props }) => {
  const description = 'This button is currently disabled';
  return disabled ? (
    <>
      <AriaDescription id="description">{description}</AriaDescription>
      <PrimaryButtonWrapper
        color={Colors.Black}
        bgColor={Colors.MidGrey}
        disabled={true}
        aria-disabled="true"
        role="button"
        aria-describedby={description}
        {...props}
      >
        {children}
      </PrimaryButtonWrapper>
    </>
  ) : (
    <PrimaryButtonWrapper color={Colors.White} {...props}>
      {children}
    </PrimaryButtonWrapper>
  );
};

export default PrimaryButton;
